<template lang="html">
  <d-input-group class="mb-3 discount">
    <d-form-input
      type="number"
      min="1"
      v-model="period"
      id="feWarranty"
      class="text-right"
      placeholder="Período"
    />
    <d-input-group-addon append>
      <select
        class="input-group-text form-control custom-select"
        v-model="periodType"
      >
        <option value="mes" selected>mês</option>
        <option value="ano">ano</option>
      </select>
    </d-input-group-addon>
  </d-input-group>
</template>

<script>
export default {
  name: 'InputWarranty',
  props: {
    warranty: {
      required: true,
      default: null,
    },
    warrantyTypeId: {
      required: true,
      default: null,
    },
  },
  computed: {
    period: {
      get() {
        return this.warranty;
      },
      set(val) {
        if (val === '') {
          this.$emit('update:warrantyTypeId', null);
        }
        if (val && !this.warrantyTypeId) {
          this.$emit('update:warrantyTypeId', 'mes');
        }
        this.$emit('update:warranty', val);
      },
    },
    periodType: {
      get() {
        return this.warrantyTypeId;
      },
      set(val) {
        this.$emit('update:warrantyTypeId', val);
      },
    },
  },
  mounted() {
    this.period = this.warranty;
    this.periodType = this.warrantyTypeId;
  },
};
</script>
